import React from 'react';
import {useTrackEvent, UseTrackEventProps} from '../../../hooks';

export interface TrackEventProps extends UseTrackEventProps {
    children: (trackEvent: ReturnType<typeof useTrackEvent>) => React.ReactNode;
}

/**
 * Example
 * <TrackEvent eventCategory="MediaCreator" eventAction="ClickChart">
 *  {trackEvent => (
 *      <Component onClick={() => trackEvent('Begin')} />
 *  )}
 * </TrackEvent>
 */
const TrackEvent = ({children, ...rest}: TrackEventProps) => {
    const trackEvent = useTrackEvent(rest);

    if (typeof children !== 'function') {
        return children;
    }

    return <>{children(trackEvent)}</>;
};

export default TrackEvent;
